import { apiClient } from './client.tsx';

export const fetchSiteProviders = () =>
  apiClient.get('/maas_billing/site_providers').then((res) => res.data.data);

export const fetchSiteProviderStores = (id: string) =>
  apiClient
    .get(`/maas_billing/site_providers/${id}/stores`)
    .then((res) => res.data.data);

export const fetchSiteProviderAccountants = (id: string) =>
  apiClient
    .get(`/maas_billing/site_providers/${id}/accountants`)
    .then((res) => res.data.data);
